export function removePunctuation(string: string) {
  return string.replace(/[.?!,:]/g, '')
}
